import React from "react";

const IntegrationSuccess = () => {
  const handleClose = () => {
    // Inform parent window
    if (window.opener) {
      window.opener.postMessage(
        { type: "GMAIL_INTEGRATION_SUCCESS", payload: { status: "ok" } },
        "*"
      );
    }
    window.close();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center p-6 bg-white">
      <img
        src="/images/gmail_logo.png"
        alt="Success"
        className="w-32 max-w-full mb-6"
      />
      <h2>Gmail </h2>
      <h3 className="text-2xl font-bold mb-2">Integration Successful!</h3>
      <p className="mb-6">Your integration has been completed successfully.</p>
      <button
        variant="solid"
        onClick={handleClose}
        className="bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-1 rounded"
      >
        OK
      </button>
    </div>
  );
};

export default IntegrationSuccess;
